import { useSharedModelController } from '../../hooks/use-shared-model-controller';
import { initialUserInfo } from './models/user-info';
import { UserInfoController } from './user-info-controller';

export function useUserInfo() {
  const { model: userInfoModel, delegate: userInfoDelegate } = useSharedModelController(initialUserInfo, UserInfoController);
  return { userInfoModel, userInfoDelegate };
}
